import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Container } from './Container'

export const MinorCitySecondSection: React.FC<{
  title: string
  subheading: string
  firstReasonWhy: ReasonWhy
  secondReasonWhy: ReasonWhy
  thirdReasonWhy: ReasonWhy
}> = ({ title, subheading, firstReasonWhy, secondReasonWhy, thirdReasonWhy }) => {
  return (
    <section className="text-center">
      <Container>
        <div>
          <h2 className="title">{title}</h2>
          <p style={{ color: '#7c7c7c' }}>{subheading}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3">
          <ReasonWhyItem {...firstReasonWhy} />
          <ReasonWhyItem {...secondReasonWhy} />
          <ReasonWhyItem {...thirdReasonWhy} />
        </div>
      </Container>
    </section>
  )
}

type ReasonWhy = { title: string; subheading: string; icon: IconProp }

const ReasonWhyItem: React.FC<ReasonWhy> = ({ title, subheading, icon }) => {
  return (
    <div className="flex flex-grow flex-col h-100 py-8">
      <p>
        <FontAwesomeIcon size={'4x'} icon={icon} color={'#ea3616'} />
      </p>
      <div className="mt-auto">
        <h3 style={{ paddingTop: 20, fontSize: 18, fontWeight: 900 }}>{title}</h3>
        <p className="m-0">{subheading}</p>
      </div>
    </div>
  )
}
